// extracted by mini-css-extract-plugin
export default {"note":"EmailInput_note__XzPRx","checkmarkIcon":"EmailInput_checkmarkIcon__tDq8P","button":"EmailInput_button__JWTpa"};